export const translations = {
  en: {
    nav: {
      howItWorks: 'How it Works',
      products: 'Products',
      tokenomics: 'Tokenomics',
      roadmap: 'Roadmap',
      community: 'Community',
      buy: 'Buy $APEX',
    },
    hero: {
      eyebrow: 'TON Blockchain · DeFi Growth Token',
      title1: 'The token that',
      title2: 'grows with',
      title3: 'real business',
      sub: 'APEX is a DeFi token on TON. 50% of net profit from top-10 crypto liquidity pools is allocated to regular buybacks of $APEX from the open market — driving sustainable, long-term price appreciation.',
      buyBtn: 'Buy on Blum',
      dexBtn: 'DexScreener',
      stat1Value: '1500',
      stat1Label: 'TON Raised',
      stat2Value: '24h',
      stat2Label: 'To DEX',
      stat3Value: '3 Yrs',
      stat3Label: 'In Dev',
    },
    how: {
      sectionLabel: 'Mechanism',
      title: 'How APEX works',
      sub: 'Value is generated by real liquidity operations — not speculation.',
      card1Title: 'Liquidity Pools',
      card1Body: 'The team deploys capital into liquidity pools of top-10 crypto assets: ETH, BTC, and others. Attracted funds work as LP and generate steady yield around the clock.',
      card2Title: '50% Buyback',
      card2Body: '50% of the company\'s net profit is regularly used to buy back $APEX from the open market. As business scales, buyback volume scales with it — creating constant upward pressure.',
      card3Title: 'Price Appreciation',
      card3Body: 'Systematic buybacks reduce circulating supply and push the price higher. Deep liquidity ensures you can buy or sell $APEX at any time without slippage.',
    },
    products: {
      sectionLabel: 'Our Ecosystem',
      title: 'Products built on $APEX',
      sub: 'Beyond buybacks — real, working products that generate revenue inside the APEX ecosystem.',
      dexBadge: 'Our Product',
      dexTitle: 'Velarion — DEX & Lending',
      dexBody: 'A decentralized platform for swapping and lending crypto assets. Part of the same ecosystem that drives real demand for $APEX.',
      dexBtn: 'Open Velarion',
      energyBadge: 'Our Product',
      energyTitle: 'Tron Energy',
      energyBody: 'A landing page for renting TRON Energy — cheaper on-chain transactions without holding extra TRX for fees.',
      energyBtn: 'Open Tron Energy',
      botBadge: 'Our Product',
      botTitle: 'Tron Enerjy Bot',
      botBody: 'A Telegram bot for buying TRON Energy instantly, right from the chat — fast, simple, always available.',
      botBtn: 'Open the Bot',
    },
    tokenomics: {
      sectionLabel: 'Tokenomics',
      title: 'Profit Distribution',
      sub: 'of the company\'s net profit goes to buying back $APEX from the open market — every single period.',
      bar1: '$APEX Buyback from market',
      bar2: 'Reinvestment into LP pools',
      bar3: 'Operations & Development',
      tag1: 'Locked LP',
      tag2: 'Audited Contract',
      tag3: 'Transparent',
      note: 'Real utility, real demand. Every LP fee earned directly funds market purchases of $APEX — aligning the token price with business performance.',
      noteHighlight: 'Real utility, real demand.',
    },
    chart: {
      sectionLabel: 'Live Chart',
      title: 'Watch it grow, live',
      sub: 'Real-time $APEX/GRAM chart powered by DexScreener. No delays, no filters — the market speaks for itself.',
    },
    ecosystem: {
      sectionLabel: 'Ecosystem',
      title: 'Multi-chain from day one',
      sub: 'Fast and low-cost transactions across multiple blockchain ecosystems.',
    },
    roadmap: {
      sectionLabel: 'Roadmap',
      title: 'Not a sprint. A marathon.',
      sub: 'Three years in development before launch. No hype, no pump-and-dump — just steady, confident growth.',
      phase1Label: 'Phase 1 — Complete',
      phase1Title: 'Token Launch',
      phase1Items: [
        'Official $APEX launch on TON',
        '1206 TON raised within first 24 hours',
        'Full 1500 TON target hit in under 48h',
        'Listed on DEX — trading live',
      ],
      phase2Label: 'Phase 2 — In Progress',
      phase2Title: 'Liquidity & Stability',
      phase2Items: [
        'Active liquidity provisioning',
        'First buyback operations executed',
        'Price stabilisation post-listing',
        'Community growth & partnerships',
      ],
      phase3Label: 'Phase 3 — Upcoming',
      phase3Title: 'Ecosystem Expansion',
      phase3Items: [
        'New DeFi products and verticals',
        'Expanded LP across top-10 assets',
        'Regular scheduled $APEX buybacks',
        'Multi-chain ecosystem growth',
      ],
    },
    community: {
      sectionLabel: 'Community',
      title: 'Join the movement',
      sub: 'Follow updates, discuss the project, and trade $APEX right now.',
      card1Title: 'Telegram Channel',
      card1Sub: '@apextokenLIkUB · News & updates',
      card2Title: 'Community Chat',
      card2Sub: 'Discussions & support',
      card3Title: 'DexScreener',
      card3Sub: 'Live chart · $APEX / TON',
      card4Title: 'Buy on Blum',
      card4Sub: 'Mini-app · Instant $APEX purchase',
    },
    cta: {
      sectionLabel: 'Get Started',
      title1: '$APEX: the token backed',
      title2: 'by real liquidity operations',
      sub: 'No pump. No dump. Sustainable buyback-driven growth with transparent tokenomics and locked LP.',
      btn1: 'Buy $APEX on Blum',
      btn2: 'View Chart',
    },
    footer: {
      copy: '© 2025 APEX Token · $APEX · TON Blockchain',
      link1: 'Channel',
      link2: 'Chat',
      link3: 'DexScreener',
      link4: 'Buy',
    },
  },

  ru: {
    nav: {
      howItWorks: 'Как работает',
      products: 'Продукты',
      tokenomics: 'Токеномика',
      roadmap: 'Roadmap',
      community: 'Сообщество',
      buy: 'Купить $APEX',
    },
    hero: {
      eyebrow: 'TON Блокчейн · DeFi Токен роста',
      title1: 'Токен, который',
      title2: 'растёт вместе',
      title3: 'с реальным бизнесом',
      sub: 'APEX — DeFi-токен на TON. 50% чистой прибыли от пулов ликвидности топ-10 криптоактивов направляется на регулярный выкуп $APEX с открытого рынка — обеспечивая устойчивый долгосрочный рост цены.',
      buyBtn: 'Купить на Blum',
      dexBtn: 'DexScreener',
      stat1Value: '1500',
      stat1Label: 'TON собрано',
      stat2Value: '24ч',
      stat2Label: 'До DEX',
      stat3Value: '3 года',
      stat3Label: 'Разработки',
    },
    how: {
      sectionLabel: 'Механика',
      title: 'Как работает APEX',
      sub: 'Ценность формируется реальными операциями с ликвидностью — не спекуляциями.',
      card1Title: 'Пулы ликвидности',
      card1Body: 'Команда размещает капитал в пулы ликвидности топ-10 криптоактивов: ETH, BTC и других. Привлечённые средства работают как LP и генерируют стабильный доход круглосуточно.',
      card2Title: '50% Buyback',
      card2Body: '50% чистой прибыли компании регулярно направляется на выкуп $APEX с открытого рынка. По мере роста бизнеса объём обратного выкупа растёт вместе с ним.',
      card3Title: 'Рост капитализации',
      card3Body: 'Систематический buyback сокращает обращающееся предложение и поднимает цену. Глубокая ликвидность позволяет покупать и продавать $APEX в любое время без проскальзывания.',
    },
    products: {
      sectionLabel: 'Наша экосистема',
      title: 'Продукты на базе $APEX',
      sub: 'Не только buyback — реальные продукты, которые уже работают и приносят доход внутри экосистемы APEX.',
      dexBadge: 'Наш продукт',
      dexTitle: 'Velarion — DEX и кредитование',
      dexBody: 'Децентрализованная платформа для обмена и кредитования криптовалют. Часть единой экосистемы, формирующей реальный спрос на $APEX.',
      dexBtn: 'Перейти в Velarion',
      energyBadge: 'Наш продукт',
      energyTitle: 'Tron Enerjy',
      energyBody: 'Лендинг для аренды энергии TRON — более дешёвые транзакции без необходимости держать лишний TRX на комиссию.',
      energyBtn: 'Перейти на Tron Enerjy',
      botBadge: 'Наш продукт',
      botTitle: 'Tron Enerjy Bot',
      botBody: 'Telegram-бот для мгновенной покупки энергии TRON прямо в чате — быстро, просто и всегда под рукой.',
      botBtn: 'Открыть бота',
    },
    tokenomics: {
      sectionLabel: 'Токеномика',
      title: 'Распределение прибыли',
      sub: 'чистой прибыли компании направляется на выкуп $APEX с открытого рынка — в каждом отчётном периоде.',
      bar1: 'Выкуп $APEX с рынка',
      bar2: 'Реинвестиции в пулы ликвидности',
      bar3: 'Операции и развитие',
      tag1: 'Locked LP',
      tag2: 'Audited Contract',
      tag3: 'Прозрачно',
      note: 'Реальная полезность, реальный спрос. Каждая комиссия LP напрямую финансирует рыночные покупки $APEX — цена токена привязана к росту бизнеса.',
      noteHighlight: 'Реальная полезность, реальный спрос.',
    },
    chart: {
      sectionLabel: 'График в реальном времени',
      title: 'Смотрите рост вживую',
      sub: 'График $APEX/GRAM в реальном времени с DexScreener. Без задержек и фильтров — рынок говорит сам за себя.',
    },
    ecosystem: {
      sectionLabel: 'Экосистема',
      title: 'Мульти-чейн с первого дня',
      sub: 'Быстрые и недорогие транзакции сразу в нескольких блокчейн-экосистемах.',
    },
    roadmap: {
      sectionLabel: 'Roadmap',
      title: 'Не спринт. Марафон.',
      sub: 'Три года разработки до запуска. Никакого хайпа, никаких памп-дампов — только стабильный уверенный рост.',
      phase1Label: 'Фаза 1 — Завершено',
      phase1Title: 'Запуск токена',
      phase1Items: [
        'Официальный запуск $APEX на TON',
        '1206 TON собрано за первые 24 часа',
        'Цель в 1500 TON достигнута менее чем за 48ч',
        'Листинг на DEX — торги открыты',
      ],
      phase2Label: 'Фаза 2 — В процессе',
      phase2Title: 'Ликвидность и стабильность',
      phase2Items: [
        'Активное предоставление ликвидности',
        'Первые операции buyback выполнены',
        'Стабилизация цены после листинга',
        'Рост сообщества и партнёрства',
      ],
      phase3Label: 'Фаза 3 — Планируется',
      phase3Title: 'Расширение экосистемы',
      phase3Items: [
        'Новые DeFi-продукты и направления',
        'Расширение LP на топ-10 активов',
        'Регулярные плановые buyback $APEX',
        'Рост мульти-чейн экосистемы',
      ],
    },
    community: {
      sectionLabel: 'Сообщество',
      title: 'Присоединяйтесь',
      sub: 'Следите за обновлениями, обсуждайте проект и торгуйте $APEX прямо сейчас.',
      card1Title: 'Telegram-канал',
      card1Sub: '@apextokenLIkUB · Новости и обновления',
      card2Title: 'Чат сообщества',
      card2Sub: 'Обсуждения и поддержка',
      card3Title: 'DexScreener',
      card3Sub: 'Живой график · $APEX / TON',
      card4Title: 'Купить на Blum',
      card4Sub: 'Мини-апп · Мгновенная покупка $APEX',
    },
    cta: {
      sectionLabel: 'Начать',
      title1: '$APEX: токен, обеспеченный',
      title2: 'реальными операциями с ликвидностью',
      sub: 'Никакого памп-дампа. Устойчивый рост на основе buyback с прозрачной токеномикой и заблокированным LP.',
      btn1: 'Купить $APEX на Blum',
      btn2: 'Смотреть график',
    },
    footer: {
      copy: '© 2025 APEX Token · $APEX · TON Blockchain',
      link1: 'Канал',
      link2: 'Чат',
      link3: 'DexScreener',
      link4: 'Купить',
    },
  },
};
